export const POST_TYPE = {
  BACK: 'back',
  CLOSE: 'close',
  LOGIN: 'login',
  LOGIN_REQUEST: 'loginRequest',
  REGISTER: 'register',
  DOWNLOAD: 'download',
  // 履约提货
  AGREEMENT: 'agreement',
  // 下单
  BUY: 'buy',
  // 充值
  RECHARGE: 'recharge',
  // 我的
  MINE_PAGE: 'minePage',
  // 红包
  RED_ENVELOPE: 'redEnvelope',
  // 任务中心
  TASK_CENTER: 'taskCenter',
  // 积分商城
  INTEGRAL: 'integral',
  // 晒单
  ORDER: 'order',
  // 页面刷新
  PAGE_REFRESH: 'pageRefresh'
}
